// Yandex Metrika
(function ($) {

    function YandexMetrika(options) {
        if (!options) {
            throw new Error('No options passed to YandexMetrika constructor');
        } else if (!options.metrikaID) {
            throw new Error('No metrika ID passed to YandexMetrika constructor');
        }

        this.options = $.extend({}, YandexMetrika.defaults, options);

        this.setup();
    }

    /**
     * Setup envelopment
     */
    YandexMetrika.prototype.setup = function () {
        let body = $('body');
        let self = this;

        body.on('click', '[data-metrika-target]:not(a)', function (event) {

            let metrikaTarget = self.getYandexMetrikaTarget(event.target);
            if (metrikaTarget) {
                self.sendEvent(metrikaTarget);
            }
        });

        body.on('click', 'a', function (event) {
            let href = event.target.href;
            if (typeof href === "undefined") {
                const closestElement = $(event.target).closest('a');
                href = closestElement.attr('href');
            }

            let metrikaTarget = self.getYandexMetrikaTarget(event.target);
            if (metrikaTarget) {
                try {
                    if (typeof href === "undefined") {
                        event.preventDefault();
                    }
                    self.sendEvent(metrikaTarget);

                } catch (error) {
                    console.error(error);
                }
            } else {
                return;
            }

            if (typeof href === "undefined") {
                window.location.href = href;
            }
        });
    };

    /**
     * Returns Yandex Metrika target from data attribute
     *
     * @param target
     * @returns string
     */
    YandexMetrika.prototype.getYandexMetrikaTarget = function (target) {
        let metrikaTarget = $(target).data('metrika-target');
        if (typeof metrikaTarget === "undefined") {
            const closestElement = $(target).closest('[data-metrika-target]');
            metrikaTarget = closestElement.data('metrika-target');
        }

        if (typeof metrikaTarget === "undefined") {
            return '';
        }

        return metrikaTarget;
    }

    /**
     * Send data to Yandex Metrika
     *
     * @param {string} metrikaTarget - Yandex Metrika Target
     */
    YandexMetrika.prototype.sendEvent = function (metrikaTarget) {
        try {
            if (typeof ym !== 'function') {
                throw new Error('Yandex Metrika (ym) function not exists');
            }

            if (!metrikaTarget) {
                throw new Error('metrikaTarget is required');
            }

            ym(this.options.metrikaID, 'reachGoal', metrikaTarget);
        } catch (e) {
            console.log(e.toString());
            // Do nothing
        }
    }

    window.YandexMetrika = YandexMetrika;

})(jQuery);
